import { getColor } from '../../../../assets/theme';
import {
  Box,
  Typography,
  Grid,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { RoomPostingLedgerData } from '../../interface/room-posting-interface';

interface Props {
  titleBreakdown: string;
  rowValue: string;
  rowData: RoomPostingLedgerData;
}

const CustomToolTip: React.FC<Props> = ({
  titleBreakdown,
  rowValue,
  rowData,
}) => {
  const { textColor, white } = getColor();

  // const getGross = ({
  //   charges,
  //   payment,
  //   adjustments,
  // }: {
  //   charges: string;
  //   payment: string;
  //   adjustments: string;
  // }): string => {
  //   let decCharges: number = parseFloat(charges.replace(/,/g, ''));
  //   let decPayment: number = parseFloat(payment.replace(/,/g, ''));

  //   if (decCharges > 0) {
  //     return charges;
  //   } else if (decPayment > 0) {
  //     return payment;
  //   } else {
  //     return adjustments;
  //   }
  // };

  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  return (
    <LightTooltip
      title={
        <Box
          id='custom-tooltip'
          sx={{
            pt: '10px',
            pl: '5px',
            width: '220px',
            height: '240px',
            backgroundColor: white,
            borderRadius: '3px',
          }}
        >
          <Typography
            sx={{ fontSize: '12px', fontWeight: 'bold', color: textColor }}
          >
            {titleBreakdown}
          </Typography>

          <ListItem>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <ListItemText
                  secondary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      Gross
                    </Typography>
                  }
                />
              </Grid>

              <Grid item xs={8}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      {rowData.gross_amount}
                    </Typography>
                  }
                  style={{ textAlign: 'right' }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider sx={{ mt: -1 }} />

          <ListItem>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      Net
                    </Typography>
                  }
                />
              </Grid>

              <Grid item xs={8}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      {rowData.net}
                    </Typography>
                  }
                  style={{ textAlign: 'right' }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider sx={{ mt: -1 }} />

          <ListItem>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      VAT
                    </Typography>
                  }
                />
              </Grid>

              <Grid item xs={8}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      {rowData.vat}
                    </Typography>
                  }
                  style={{ textAlign: 'right' }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider sx={{ mt: -1 }} />

          <ListItem>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      Service Charge
                    </Typography>
                  }
                />
              </Grid>

              <Grid item xs={6}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      {rowData.service_charge}
                    </Typography>
                  }
                  style={{ textAlign: 'right' }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider sx={{ mt: -1 }} />

          <ListItem>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      Local Tax
                    </Typography>
                  }
                />
              </Grid>

              <Grid item xs={8}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      {rowData.local_tax}
                    </Typography>
                  }
                  style={{ textAlign: 'right' }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider sx={{ mt: -1 }} />

          <ListItem>
            <Grid container spacing={1}>
              <Grid item xs={4}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      Discount
                    </Typography>
                  }
                />
              </Grid>

              <Grid item xs={8}>
                <ListItemText
                  primary={
                    <Typography sx={{ fontSize: '10px', color: textColor }}>
                      {rowData.discount}
                    </Typography>
                  }
                  style={{ textAlign: 'right' }}
                />
              </Grid>
            </Grid>
          </ListItem>
          <Divider sx={{ mt: -1 }} />
        </Box>
      }
      arrow
      enterDelay={500} // Customize delay before the tooltip appears (in milliseconds)
      enterNextDelay={200} // Customize delay before the next tooltip appears when moving from one tooltip to another (in milliseconds)
    >
      <Typography sx={{ textAlign: 'right' }}>{rowValue}</Typography>
    </LightTooltip>
  );
};

export default CustomToolTip;
